export enum TIME_GROUPS {
  HOUR_12 = 'hour12',
  HOUR_24 = 'hour24',
  MINUTE = 'minute',
  MERIDIEM = 'meridiem',
  SECOND = 'second',
  MILLISECOND = 'millisecond',
}

const { HOUR_12, HOUR_24, MINUTE, MERIDIEM, SECOND, MILLISECOND } = TIME_GROUPS;

export const MERIDIEM_VALUES = 'AM|PM';
export const MERIDIEM_REGEX = new RegExp(`(${MERIDIEM_VALUES})`, 'i');
export const REGEX_PARTS_TIME = {
  HH_12: `(?<${HOUR_12}>\\d{1,2})`, // Match 1 or 2 digits; validation comes later
  HH_24: `(?<${HOUR_24}>\\d{1,2})`, // Same — defer strict rules to parser
  MM: `(?<${MINUTE}>\\d{2})`, // Matches 2-digit minutes
  SS: `(?<${SECOND}>\\d{2})`,
  SSS: `(?<${MILLISECOND}>\\d{1,3})`,
  AMPM: `(?<${MERIDIEM}>${MERIDIEM_VALUES})`, // Matches AM/PM
  SEP: '[:\\s]', // Flexible separator between hour and minute
  SPACE_OPT: `\\s?`, // Optional space
  DOT: '\\.',
};
